import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import type { GardenLayout } from '../../types/gardenLayout';

interface GardenLayoutCardProps {
  layout: GardenLayout;
}

export default function GardenLayoutCard({ layout }: GardenLayoutCardProps) {
  const [imageLoaded, setImageLoaded] = React.useState(false);

  const formattedDate = new Date(layout.date).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <Link to={`/layouts/${layout.slug}`} className="group block">
      <div className="rounded-lg overflow-hidden shadow-sm transition-shadow group-hover:shadow-md relative aspect-[9/16] bg-gray-200">
        {/* Skeleton */}
        <div
          className={`absolute inset-0 bg-gray-200 transition-opacity duration-300 ${
            imageLoaded ? 'opacity-0' : 'opacity-100'
          }`}
        />

        {/* Photo */}
        <img
          src={layout.thumbnailUrl}
          alt={layout.title}
          onLoad={() => setImageLoaded(true)}
          className={`absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
        />

        {/* Bottom gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

        {/* Text overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-white font-semibold text-sm leading-snug mb-1.5">
            {layout.title}
          </h3>
          <div className="flex items-center gap-1.5 text-white/70 text-xs">
            <Calendar className="h-3 w-3" />
            <span>{formattedDate}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
